// components/inputs/CountryCitySelect.js

import React, { useEffect, useState } from "react";
import { Country, City } from "country-state-city";
import { Input, Label } from "reactstrap";

const CountryCitySelect = ({
  country,
  city,
  setCountry,
  setCity,
  cityError,
  countryError,
}) => {
  const [selectedCountryCode, setSelectedCountryCode] = useState("");
  const [cityList, setCityList] = useState([]);

  useEffect(() => {
    if (country) {
      const selected = Country.getAllCountries().find(
        (c) => c.name === country
      );
      if (selected) {
        setSelectedCountryCode(selected.isoCode);
        setCityList(City.getCitiesOfCountry(selected.isoCode));
      }
    }
  }, [country]);

  const handleCountryChange = (e) => {
    const selectedCode = e.target.value;
    const selected = Country.getAllCountries().find(
      (c) => c.isoCode === selectedCode
    );

    setSelectedCountryCode(selectedCode);
    setCountry(selected?.name || ""); // Store name in parent
    setCity("");
    setCityList(City.getCitiesOfCountry(selectedCode));
  };

  const handleCityChange = (e) => {
    setCity(e.target.value);
  };

  return (
    <div>
      <Input
        type="select"
        placeholder="Select Country"
        className={`normal-input mb-3 ${countryError ? "border-danger" : ""}`}
        value={selectedCountryCode}
        onChange={handleCountryChange}
      >
        {Country.getAllCountries().map((c) => (
          <option key={c.isoCode} value={c.isoCode}>
            {c.name}
          </option>
        ))}
      </Input>

      {country && (
        <Input
          type="select"
          className={`normal-input mb-3 ${cityError ? "border-danger" : ""}`}
          placeholder="Select City"
          value={city}
          onChange={handleCityChange}
          disabled={!selectedCountryCode}
        >
          {cityList.map((ct) => (
            <option key={ct.name} value={ct.name}>
              {ct.name}
            </option>
          ))}
        </Input>
      )}
    </div>
  );
};

export default CountryCitySelect;
